import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import OrientedSpeechBalloon from '../../../domain/entities/OrientedSpeechBalloon';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexOrientedSpeechBalloonsSuccess: {
      const result = action.payload as PaginatedResult<OrientedSpeechBalloon>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
